exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PackageList_tabs_1DzL {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"tabs": "PackageList_tabs_1DzL"
};